import { StringsType } from "./en"

export const da: StringsType = {
  bubbleExpiration: {
    expiredTitle: "Gratis Premium er udløbet",
    expiredSubtitle: "Opgrader til Premium for den bedste PhotoVault-oplevelse",
    expiredSubtitlePremium:
      "Opgrader til Premium for en fantastisk PhotoVault-oplevelse",
    expiredSubtitleUltimate:
      "Opgrader til Ultimate for den bedste PhotoVault-oplevelse",
    trashRecovery: "Gendannelse af papirkurv",
    cloudVault: "Cloud Vault",
    spaceSaver: "Space Saver",
    noAds: "Ingen reklamer",
    everyPremiumFeature: "Få alle\nPremium-funktioner",
    everyUltimateFeature: "Få alle\n Ultimate-funktioner",
    unlockUltimateTools: "Lås op for alle privatlivsværktøjer i appen.",
    cloudVaultUltimate: "Cloud Vault - 1.000 GB",
    organizationPlus: "Organisation+",
    organizationPlusDesc: "Opret underalbums, find dubletter og mere.",
    perMonth: "pr. måned",
    perYear: "pr. år",
    justOnce: "kun én gang",
    lifetime: "Livstid",
    threeMonths: "3 Måneder",
    lifetimeTitle: "Livstidsplan",
    lifetimeDescription:
      "Livstidsplanen vil snart være tilgængelig. Følg med for opdateringer!",
    lifetimeFeature1: "Engangsbetaling",
    lifetimeFeature2: "Livstidsadgang til alle funktioner",
    lifetimeFeature3: "Bedste værdi for langsigtede brugere",
    lifetimeCta: "Køb Lifetime",
    lifetimeSheetDisclaimer: "Cloud backup (50GB) inkluderet i 5 år.",
    lifetimeSheetDisclaimerDetailed:
      "5 år af Cloud Vault backup (50 GB) er inkluderet i din livstidsplan. Derefter er du berettiget til et rabatteret Cloud Vault abonnement, der kun er tilgængeligt for livstidsmedlemmer. Alle Premium-funktioner vil altid forblive tilgængelige uden ekstra omkostninger.",
    lifetimeDisclaimerCloudStorage:
      "5 år af Cloud Vault backup (50 GB) er inkluderet i din livstidsplan.",
    lifetimeDisclaimerAfterPeriod:
      "Efter 5 år er du berettiget til et rabatteret Cloud Vault abonnement, der kun er tilgængeligt for livstidsmedlemmer.",
    lifetimeDisclaimerPremiumFeatures:
      "Alle Premium-funktioner vil altid forblive tilgængelige uden ekstra omkostninger.",
    monthly: "Månedligt",
    yearly: "Årligt",
    selectPlan: "Vælg en plan for at fortsætte",
    unlockPrivacyTools: "Lås op for fremragende privatlivsværktøjer.",
    cloudVaultGB: "Cloud Vault - 50 GB",
    secureBackups: "Sikre backups der forbliver krypterede.",
    freeUpSpace: "Frigør plads på din telefon.",
    recoverDeleted: "Genskab slettede elementer fra papirkurven.",
    fullExperience: "Den fulde oplevelse uden afbrydelser.",
    restorePurchases: "Gendan køb",
    basicTitle: "Private Photo Vault Basic",
    free: "GRATIS",
    basicDescription:
      "Basic er den gratis version af PhotoVault. Den beskytter stadig dine vigtige fotos bag en PIN-skærm og giver dig gode privatlivsfunktioner.",
    switchToBasic: "Skift til Basic",
    termsOfService: "Servicevilkår",
    privacy: "Privatliv",
    switchToPremium: "Skift til Premium",
    switchToUltimate: "Skift til Ultimate",
    premiumExpiredTitle: "Premium er udløbet",
    ultimateExpiredTitle: "Ultimate er udløbet",
    renewSubtitle: "Forny for den bedste Private Photo Vault oplevelse",
    selectPlanOrSwitchToPro: "Vælg en plan eller skift til Pro gratis",
    selectPlanOrSwitchToBasic: "Vælg en plan eller skift til Basic gratis",
    proTitle: "Private Photo Vault - Pro",
    purchased: "Købt",
    proDescription:
      "Da du tidligere har købt engangs Pro-versionen, vil du kunne fortsætte med at bruge alle Pro-funktioner, du tidligere har betalt for.",
    switchToPro: "Skift til Pro",
    subscribeFor: (price: string) => `Abonner for ${price}/år`,
    subscribeForMonth: (price: string) => `Abonner for ${price}/måned`,
    billedPerYear: (price: string) => `faktureres ${price} pr. år`,
    oneStepSubtitle:
      "Opgrader til Premium for den bedste\nPrivate Photo Vault oplevelse",
    oneStepSubtitleUltimate:
      "Opgrader til Ultimate for den bedste\nPrivate Photo Vault oplevelse",
    purchaseWithAppStore: "Køb med App Store",
  },
  title: "Ubegrænset adgang til alle funktioner",
  freeTrial: "Gratis prøve",
  startPlan: "Start abonnement",
  pricePerMonth: (price: any) => `${price}/md.`,
  pricePerYear: (price: any) => `faktureres som ${price}/år`,
  freeTrialDescriptionYearly: (days: number, price: string) =>
    `${days} dages gratis, derefter ${price}/år. Opsig når som helst`,
  freeTrialDescriptionMonthly: (days: number, price: string) =>
    `${days} dages gratis, derefter ${price}/md. Opsig når som helst`,
  discount: (discount: number) => `${discount}% RABAT`,
  new: "nyt",
  trashRecovery: "Gendan papirkurv",
  adFree: "Reklamefri oplevelse",
  breakIn: "Indbrudsrapport: foto & GPS",
  wireless: "Trdls Billedeoverfrsel",
  decoy: "Lokke-adgangskode",
  pattern: "Mnsterls",
  appDisguise: "App-skjuler",
  comingSoon: "kommer snart",
  subscriptionTerms: "Abonnementsvilkår:",
  terms:
    "Betaling vil blive opkrævet via din iTunes Account ved bekræftelsen af købet. Abonnementet vil automatisk blive fornyet medmindre auto-fornyelse er slået fra mindst 24-timer før slutningen af den aktuelle periode. Kontoen vil blive opkrævet for fornyelse inden for 24-timer forud for slutningen af den aktuelle periode. Du kan administrere dit abonnement og slå auto-fornyelse fra ved at gå til dine kontoindstillinger efter købet.",
  privacy: "Privatliv",
  alreadyPurchased: "Allerede købt?",
  termsButton: "Vilkår",
  monthly: "MÅNEDLIGT",
  yearly: "ÅRLIGT",
  popular: "POPULÆRE",
  save: (discount) => `SPAR ${discount}%`,
  anniversaryTitle: (discount) => `Jubilæumstilbud - SPAR ${discount}%`,
  blackFridayTitle: (discount) => `Black Friday - SPAR ${discount}%`,
  year: "år",
  years: "år",
  hour: "time",
  hours: "timer",
  minute: "minut",
  minutes: "minutter",
  second: "sekund",
  seconds: "sekunder",
  promoSubtitle: (hours) =>
    `Skynd dig, dette tilbud varer kun i ${hours} timer`,
  offerExpires: "Indtil tilbuddet udløber",
  unlockDeal: "Lås op for tilbuddet",
  blackFridayPaywallTitle: "Black Friday-tilbud",
  anniversaryPaywallTitle: "Dit jubilæumstilbud 🎉",
  blackFridayPaywallSubtitle:
    "Gå ikke glip af dette enestående tilbud til Black Friday! Få kæmpe besparelser på vores årlige abonnement.",
  anniversaryPaywallSubtitle: (years: number, discount: number) =>
    `Tillykke med ${years} år hos os! For at fejre det får du en rabat på ${discount}% på Premium. Tak for din loyalitet!`,
  blackFridayAnnualTitle: "Dit Black Friday-tilbud 🎉",
  anniversaryAnnualTitle: "Dit jubilæumstilbud 🎉",
  oneYear: "1 år",
  oneMonth: "1 måned",
  lockedIn: "Denne årlige pris vil være låst fast FOR EVIGT",
  subtitleFixed: "Skynd dig, denne udsalg slutter snart!",
  importTitle: "Start dit hvelv",
  importSubtitle: "Det er 100% privat!",
  importInfo: "Tilføj fotos og videoer, du vil holde skjult og sikre.",
  importCTA: "Tilføj til hvelv",
  skip: "Spring over",
  totalMonthsPrice: (price: string) => `12 md. • ${price}`,
  monthlyPrice: (price: string) => `${price} / md.`,
  oneTimeOffer: {
    title: "Dit engangstilbud",
    subTitle: "Når du lukker dit engangstilbud, er det væk!",
    claim: "Gør krav på dit engangstilbud",
  },
  returnOffer: {
    monthly: (price: string) => `så lavt som ${price}/måned`,
    title: "Dit Eksklusive Tilbagevendenstilbud",
    subTitle:
      "Genaktiver dit medlemskab i dag til en speciel pris! Kun tilgængelig i begrænset tid",
    discountTitle: "Særlig Rabat",
    cta: "Genaktiver Nu",
    discountSubTitle: "Tidsbegrænset tilbud",
  },
  off: "RABAT",
  special: "SPECIAL",
  yearlyPlan: "Årlig Plan",
  monthlyPlan: "Månedsplan",
  subscribe: "Abonner",
  cancelAnytime: "Opsig når som helst",
  freeTrialPaywall: {
    title: "Sådan fungerer din gratis prøveperiode",
    firstStep: {
      title: "Nu",
      subtitle:
        "Få ubegrænset adgang til Private Photo Vault og bekymre dig aldrig om, at nogen ser dine private billeder igen",
    },
    secondStep: {
      title: "I dag: Start din gratis prøveperiode",
      subtitle:
        "Få fuld adgang til PhotoVault. Du vil ikke blive opkrævet i dag.",
    },
    thirdStep: {
      title: "Om 7 dage",
      subtitle:
        "Du vil blive opkrævet denne dag. Annuller når som helst inden, problemfrit.",
    },
    whatsIncluded: "Se hvad der er inkluderet",
    viewAllPlans: "Se alle planer",
    startTrial: "Start gratis prøveperiode",
    footerTitle: (yearlyPrice, monthlyPrice) =>
      `7 dage GRATIS og derefter ${yearlyPrice}/år\n(${monthlyPrice} per måned)`,
    footerDisclaimer:
      "Annuller når som helst før din prøveperiode slutter. Du vil kun blive opkrævet efter 7 dage",
    featureList: {
      title: "Hvad er Private Photo Vault?",
      infoTitle: "100% Privat og Sikker",
      infoSubtitle: "Beskyt dine data og forhindre uautoriseret adgang",
      subTitle: "Bliv Premium og få adgang til:",
    },
    comparePlans: {
      monthly: "Månedlig",
      yearly: "Årlig",
      ultimateYearly: "Ultimate årligt",
      threeMonths: "3 måneder",
      freeFor: (days) => `Gratis i ${days} dage`,
      monthlyPrice: (price) => `kun ${price}/måned`,
      dailyPrice: (price) => `kun ${price}/dag`,
      cta: "Fortsæt",
    },
  },
  comparePlans: {
    title: "Sammenlign planer",
    compare: "Sammenlign",
    freeTitle: "Gratis",
    basicTitle: "Basis",
    premiumTitle: "Premium",
    ultimateTitle: "Ultimate",
    unlockPremium: "Lås op for Premium",
    unlockUltimate: "Lås op for Ultimate",
    choose: "Vælg en plan",
  },
  features: {
    organizationPlus: "Organisering+",
    securityPlus: "Sikkerhed+",
    duplicateDetection: "Dubletregistrering",
    faceDownLock: "Ansigt nedad-lås",
    customIcons: "Brugerdefinerede ikoner",
    encryptedStorage: "Krypteret fotolagring",
    unlimitedAlbums: "Ubegrænsede album",
    browser: "Sikker webbrowser",
    camera: "Privat kamera",
    subalbums: {
      title: "Underalbum",
      description:
        "Opret flere niveauer af underalbummer for at organisere dit indhold effektivt.",
    },
    filteringAndSearching: {
      title: "Filtrering og søgning",
      description:
        "Søg i dine albummer og anvend filtre for at finde specifikke indholdstyper.",
    },
    alphanumericPasscode: {
      title: "Alfanumerisk adgangskode",
      description:
        "Forbedr appens sikkerhed ved at bruge en alfanumerisk adgangskode.",
    },
    dualLock: {
      title: "Kræv adgangskode + Face ID",
      description:
        "For ekstra sikkerhed, kræv både adgangskode og Face ID hver gang du åbner appen.",
    },
    locationBasedLock: {
      title: "Placeringsbaseret lås",
      description:
        "Tillad kun oplåsning af appen på godkendte GPS-placeringer.",
    },
  },
  gotIt: "Forstået!",
  promo: {
    premiumSave: (percent: string) => `SPAR ${percent}% PÅ PREMIUM`,
    monthly: (price: string) => `Kun ${price}/måned`,
    yearly: (price: string) => `${price}/år`,
    limited: "BEGRÆNSET TID TILBAGE",
    claimOffer: "Gør krav på tilbuddet",
    seconds: (count: number) => (count == 1 ? "SEKUND" : "SEKUNDER"),
    minutes: (count: number) => (count == 1 ? "MINUT" : "MINUTTER"),
    oneTimeOffer: "ENGANGSTILBUD",
    normalFee: "normal gebyr",
    backTo: "tilbage til",
    yearlyShort: (price: string) => `${price}/årligt`,
  },
  premiumToUltimateBlackFriday: {
    title: "BLACK FRIDAY UDSALG",
    subTitle: "GÅ TIL ULTIMATE",
    cloud: {
      title: "1.000 GB Cloud Storage",
      description: "Sikker cloud-lagring til 500.000+ billeder",
    },
    duplicateDetection: {
      description: "Find og fjern dublerede billeder",
    },
    organizationPlus: {
      description: "Opret underalbums, filtrer og søg i dine billeder",
    },
    securityPlus: {
      description:
        "Forbedret sikkerhed med alfanumerisk adgangskode, lokationsbaseret lås og mere",
    },
    timeRemaining: "TID TILBAGE",
    saleBanner: "BEGRÆNSET TID MEGA UDSALG",
    saleTitle: "Black Friday Udsalg 🎉",
    bannerTitle: (discount: number) => `${discount}% rabat til Black Friday`,
    bannerCTA: "Få tilbuddet",
    monthPrefix: "12 md • ",
    perMonthPrice(price: string) {
      return `${price} / md`
    },
    monthly: "Månedlig",
    ultimateLaunch: {
      title: "OPGRADER TIL Ultimate",
      saleTitle: "Ultimate Lanceringstilbud 🚀",
      bannerTitle: (discount) => `Ultimate Lancering - SPAR ${discount}%`,
    },
  },
  blackFridayNoFeatures: {
    title: "BLACK FRIDAY",
    lessThanCoffee: "Mindre end en kop kaffe.",
    dontWait: "Vent ikke! Dette tilbud forsvinder snart",
    whatWaiting: "Hvad venter du på?",
    claimOffer: "GØR KRAV PÅ DIT ENGANGSTILBUD",
    moneyBack: "Pengene-tilbage-garanti",
  },
  cyberMonday: {
    title: "CYBER MONDAY",
    subTitle: "FÅ ULTIMATE",
    cloud: {
      title: "1.000 GB Cloud Storage",
      description: "Sikker cloud-lagring til 500.000+ billeder",
    },
    duplicateDetection: {
      description: "Find og fjern duplikerede billeder",
    },
    organizationPlus: {
      description: "Opret underalbum, filtrer og søg i dine billeder",
    },
    securityPlus: {
      description:
        "Forbedret sikkerhed med alfanumerisk adgangskode, placeringsbaseret lås og mere",
    },
    timeRemaining: "TID TILBAGE",
    saleBanner: "BEGRÆNSET CYBER TILBUD",
    saleTitle: "Cyber Monday Tilbud",
    bannerTitle: (discount: number) => `${discount}% RABAT på Cyber Monday`,
    bannerCTA: "Gør krav på tilbud",
    monthPrefix: "12 md • ",
    perMonthPrice(price: string) {
      return `${price} / md`
    },
    monthly: "Månedlig",
    ultimateLaunch: {
      title: "OPGRADER TIL Ultimate",
      saleTitle: "Ultimate Lanceringstilbud",
      bannerTitle: (discount: number) =>
        `Opgrader til Ultimate - SPAR ${discount}%`,
    },
  },
  beforeYouGo: {
    title: "Vent - Før du går",
    subtitle: "Hold dine billeder sikre og private",
    subtitle2: "Få 7 dages Premium helt gratis.",
    cta: "Start din gratis prøveperiode",
    cancelTitle:
      "Afbryd når som helst før din prøveperiode slutter, og du vil ikke blive opkrævet før de fulde 7 dage er op.",
    skipCta: "Nej tak",
  },
  enableTrial: "Ikke sikker endnu? Aktiver gratis prøveperiode",
  startTrial: "Start gratis prøveperiode",
  trialActivated: (days) => `${days} DAGES PRØVE AKTIVERET`,
  specialOffer: {
    enabledTitle: "Særtilbud aktiveret",
    trialTitle: "Få din ekstra 7-dages gratis prøveperiode",
    expirationTitle: "Dit abonnement udløber snart!",
    expirationSubtitle: "Forny dit abonnement til en særlig pris!",
    priceBoxExpiration: {
      title: "Særligt fornyelsestilbud",
      offerName: "Årlig plan",
      ctaTitle: "Få særligt tilbud",
    },
    priceBoxTrial: {
      title: "Eksklusivt ekstra tilbud om 7 dages gratis prøve",
      offerName: "Ekstra 7 dages prøveperiode",
      ctaTitle: "Få ekstra gratis prøve",
    },
  },
  premiumToUltimate: {
    titleLine1: "ULTIMATE OPGRADERING",
    titleLine2: "ENGANGSTILBUD",
    megaSaleBanner: "BEGRÆNSET TIDS MEGATILBUD",
    upgradeTitle: "Ultimate-opgraderingstilbud",
    yearlySubtitlePrefix: "12 mdr •",
    monthlyPriceSuffix: "/ måned",
  },
  monthlyToYearly: {
    titleLine1: "Årlig opgradering",
    titleLine2: "Engangstilbud",
    subtitleWarning: "Når du lukker dette engangstilbud, er det væk!",
    specialLabel: "SÆRLIGT",
    offerTitle: "Hent dit engangstilbud",
    offerName: "Årsplan",
    subscribeButton: "Abonner",
    cancelAnytime: "Annuller når som helst",
    yearlySubtitlePrefix: "12 mdr •",
    monthlyPriceSuffix: "/ måned",
  },
  expiration: {
    warmup: {
      close: "LUK",
      subtitle:
        "Hold dine billeder SIKRE og GENSKABELIGE, hvis din telefon bliver væk eller stjålet",
      features: {
        cloudVault: {
          title: "Cloud Vault",
          subtitle: "Krypteret backup af dine filer",
        },
        cloudVaultUltimate: {
          title: "Cloud Vault",
          subtitle: "1.000 GB Cloud Vault-lagring",
        },
        reviews: {
          title: "500.000+ 5-stjernede anmeldelser",
          subtitle: "Betroet af millioner",
        },
        noAds: {
          title: "Ingen annoncer",
          subtitle: "Annoncefri oplevelse",
        },
        organizationPlus: {
          title: "Organization+",
          subtitle: "Underalbums, bedre filtrering og mere",
        },
      },
      footer: "& alle funktioner!",
      switchToPremium: "Skift til Premium",
      switchToUltimate: "Skift til Ultimate",
      titlePremium: "Din Premium er udløbet!",
      titleUltimate: "Din Ultimate er udløbet!",
      popular: "POPULÆR",
      perMonth: "pr. måned",
      perYear: "pr. år",
    },
    titlePremium: "Premium er udløbet",
    titleUltimate: "Ultimate er udløbet",
    subtitlePremium:
      "Forny Premium for at beholde alle funktioner, eller skift til Basic gratis",
    subtitleUltimate:
      "Forny Ultimate for at beholde alle funktioner, eller skift til Basic gratis",
    basicButton: "Skift til Basic",
    basicTitle: "Hvad er Basic?",
    basicDescription:
      "Basic er den gratis version af appen. Du kan stadig beskytte dine billeder og videoer med en PIN-kode. Men du mister adgangen til den krypterede Cloud Vault-backup og alle andre Premium-funktioner",
  },
  animated: {
    title: "Vælg din plan",
    yearlyPrice: (price: string) => `Kun ${price} pr. år`,
    subtitle: "Fornyes automatisk. Aflys når som helst",
    cta: "Fortsæt",
    trial: "Gratis prøve aktiveret",
    breakinShort: "Indbrudsrapport",
    unlimitedPhotos: "Ubegrænset antal billeder",
  },
  choosePlanTitle: "Vælg Dit Abonnement",
  socialProof: {
    titleWithTrial: "Prøv Private Photo Vault\nGratis i 7 Dage",
    title: "Prøv Private Photo Vault",
    continueForFree: "Fortsæt gratis",
    continue: "Fortsæt",
    cancelAnytime: "Annuller når som helst",
    mostPopular: "Mest populære",
    twelveMonths: "12 Måneder",
    oneMonth: "1 Måned",
    yearlySubtitle: (monthlyPrice: string, yearlyPrice: string) =>
      `${monthlyPrice}/måned, faktureres som ${yearlyPrice}/år`,
    monthlySubtitle: (price: string) => `${price}/måned`,
  },
  yearlyOnlyAppStore: {
    yearly: "Årligt",
    billedYearly: (price: string) => `${price} faktureret årligt`,
    perMonth: (price: string) => `${price}/md`,
    startTrial: (days: number) => `Start ${days}-dages prøveperiode`,
    purchaseWithAppStore: "Køb med App Store  (ingen prøveperiode)",
    purchaseImmediately: "Køb med det samme  (ingen prøveperiode)",
  },
  multistep: {
    lockTitle: "Lås private fotos",
    subtitle: {
      line1: "Vi tilbyder",
      line2: "7 dage gratis",
      line3: "så alle kan beskytte deres billeder",
    },
    subtitleReminder: {
      line1: "Du får en påmindelse ",
      line2: "2 dage ",
      line3: "før din prøveperiode slutter.",
    },
    noPaymentNow: "Ingen betaling nu",
    startFreeWeek: "Start din GRATIS uge",
    payTitle: "7 dage gratis",
    afterPrice: (price: string) => `derefter ${price} / måned`,
    afterBilling: (price: string) =>
      `(faktureres ${price} årligt efter prøveperioden)`,
    footerTitle: (price) => `Gratis i 7 dage. Derefter ${price}/år`,
    footerMonthlyTitle: (price) => `Du bliver opkrævet ${price} med det samme.`,
    headerTitle: "7-dages gratis prøveperiode",
    anual: "Årlig",
    monthly: "Månedlig",
    noTrial: "Ingen gratis prøveperiode",
    yearlyPrice: (price) => `${price} / År`,
  },
  oneTimeOfferTitle: "ENGANGSTILBUD",
  unlockPremiumFor: "Lås op for årlig Premium for",
  oneTimeOfferSubtitle: "Dette er et engangstilbud",
  lowestPrice: "LAVESTE PRIS NOGENSINDE",
  summerSale: {
    title: "SOMMERUDSALG",
    tagline: "Solen ser alt... undtagen hvad der er i din boks!",
    timeRemaining: "Tilbuddet udløber snart",
    limitedTimeOffer: "Tidsbegrænset tilbud",
    savePercent: (percent: number) => `Spar ${percent}%`,
    bannerSubtitle: (price: string) => `Få Premium for ${price}`,
    bannerSubtitleUltimate: (price: string) => `Få Ultimate for ${price}`,
    getPremium: "Få Premium privatliv",
    getUltimate: "Få Ultimate privatliv",
    hours: "timer",
    minutes: "minutter",
    seconds: "sekunder",
    features: {
      premiumFeature: {
        title: "Få alle Premium-funktioner",
        description: "Premium-værktøjer der beskytter dit privatliv.",
      },
      cloudVault: {
        title: "Cloud Vault - 50 GB",
        description: "Sikre backups der forbliver krypterede.",
      },
      noAds: {
        title: "Ingen reklamer",
        description: "Den fulde oplevelse uden afbrydelser.",
      },
      faceDownLock: {
        title: "Face Down-lås",
        description: "Lås appen øjeblikkeligt ved at vende telefonen.",
      },
      breakInReports: {
        title: "Indbrudrapporter",
        description: "Advarsler hvis nogen forsøger at få adgang til din boks.",
      },
    },
    pricing: {
      summerSale: "Sommerudsalg",
      monthly: "Månedlig",
      perMonth: (price: string) => `${price} / md`,
      twelveMonths: "12 md",
      originalPrice: (price: string) => price,
      discountedPrice: (price: string) => price,
    },
  },
  autumnSale: {
    title: "EFTERÅRSUDSALG",
    tagline: "Blade dækker alt…\ninklusive dine hemmeligheder!",
    buttonTitle: "Efterårsudsalg",
  },
  halloweenSale: {
    title: "HALLOWEEN-UDSALG",
    tagline: "Natten skjuler mange ting…\nisær dine!",
    buttonTitle: "Halloween-udsalg",
  },
  winterSale: {
    title: "VINTERUDSALG",
    tagline: "Lad os beskytte dine fotos under sneen",
    buttonTitle: "Vinterudsalg",
  },
  springSale: {
    title: "FORÅRSUDSALG",
    tagline: "Opgrader til Premium med denne eksklusive forårsrabat",
    ultimateTagline: "Opgrader til Ultimate med denne eksklusive forårsrabat",
    buttonTitle: "Forårsudsalg",
  },
  emailPromo: {
    title: "Eksklusivt Premium Tilbud",
    upgradeButton: "Opgrader til Premium",
    yearlyTitle: "Premium Årligt",
    decoyDescription: "Opret en falsk boks der åbner med en lokkekode",
  },
  tabsPaywall: {
    premiumTab: "Premium",
    ultimateTab: "Ultimate",
    premiumTitle: "Lås Premium op for at",
    premiumTitleHighlight: "Sikre Din Boks",
    ultimateTitleStart: "Lås ",
    ultimateTitleHighlight: "Ultimate",
    ultimateTitleEnd: " Op For At\nFå Adgang Til Alle Funktioner",
    perMonth: "/md",
  },
  trialFooter: {
    freeTrialDays: (days: number) => `${days} dages\ngratis prøveperiode`,
    noFreeTrial: "Ingen gratis\nprøveperiode",
    noCommitment: "Ingen binding. Annuller når som helst.",
    cta: "Prøv gratis",
    ctaMonthly: "Fortsæt",
    yearly: "Årligt",
    monthly: "Månedligt",
  },
  onboardingUltimateAlternate: {
    title: "Start din gratis prøveperiode",
    premiumDescription: "Lås fremragende privatlivsværktøjer op.",
    ultimateDescription: "Den bedste Photo Vault oplevelse.",
    includesPremium: "Inkluderer Premium",
    trialPricing: (yearlyPrice: string, monthlyPrice: string) =>
      `7 dage gratis, derefter ${yearlyPrice} (${monthlyPrice}/måned)`,
    timeline: {
      today: "I dag:",
      todayDescription: "start din gratis prøveperiode",
      day5: "Dag 5:",
      day5Description: "modtag påmindelse",
      day7: "Dag 7:",
      day7Description: (yearlyPrice: string) =>
        `du bliver opkrævet ${yearlyPrice}`,
    },
    comparisonTable: {
      header: "Hvad du får",
    },
    didYouKnow: {
      label: "Vidste du?",
      statNumber: "3X",
      statDescription: "Abonnenter får 3 gange mere ro i sindet",
    },
    pricing: {
      yearlyPlanTitle: "Årsplan",
      yearlyPlanSubtitle: (yearlyPrice: string) => `${yearlyPrice}/år`,
      yearlyAmount: (monthlyPrice: string) => `${monthlyPrice}/måned`,
      monthlyTitle: "Månedlig",
      monthlyAmount: (monthlyPrice: string) => `${monthlyPrice}/måned`,
      popularBadge: "POPULÆR",
    },
    ctaButton: "Start gratis prøveperiode",
  },
  threeStepExpiration: {
    premiumExpired: "Dit Premium er udløbet",
    ultimateExpired: "Ultimate-abonnementet er udløbet",
    freeExpired: "Gratis Premium er udløbet",
    subtitle: "Din konto er blevet nedgraderet.",
    subtitlePremium: "Din konto er blevet nedgraderet.",
    subtitleUltimate: "Din konto er blevet nedgraderet.",
    allPremiumFeatures: "Alle Premium-funktioner",
    allUltimateFeatures: "Alle Ultimate-funktioner",
    spaceSaver: "Pladsbesparende",
    disabled: "Deaktiveret",
    restoreMyProtection: "Gendan fuld adgang",
    seeWhatImLosing: "Se hvad jeg mister",
    photosSafeWarning:
      "Dine fotos er sikre, men vigtige funktioner er nu deaktiveret.",
    continue: "Fortsæt",
    heresWhatYoureLosing: "Her er hvad du mister",
    allFeaturesDisabled:
      "Alle disse premium-funktioner vil blive deaktiveret på din konto:",
    allFeaturesDisabledUltimate:
      "Alle disse ultimate-funktioner vil blive deaktiveret på din konto:",
    back: "Tilbage",
    stepOf: (current: number, total: number) => `Trin ${current} af ${total}`,
    restoreAllFeatures: "Gendan alle funktioner",
    continueWithout: "Fortsæt (funktioner forbliver deaktiveret)",
    allPremiumDetail:
      "Du mister adgangen til alle premium-funktioner, der holder dine private fotos sikre og organiserede.",
    cloudVaultDetail:
      "Din cloud-backup slettes. Hvis din enhed mistes eller beskadiges, vil dine private fotos være permanent tabt.",
    cloudVaultDetailBold: "Din cloud-backup slettes.",
    cloudVaultDetailRest:
      "Hvis din enhed mistes eller beskadiges, vil dine private fotos være permanent tabt.",
    spaceSaverDetail:
      "Fotos vil optage fuld lagerplads på din enhed. Du vil ikke længere kunne komprimere og optimere din boks.",
    trashDetail:
      "Utilsigtet slettede fotos kan ikke gendannes. Når de er slettet, er de permanent væk.",
    noAdsDetail:
      "Du vil begynde at se reklamer i hele appen. Premium fjerner alle reklamer for en uafbrudt oplevelse.",
    decoyDetail:
      "Din lokke-adgangskode holder op med at virke. Alle der kender den, kan få adgang til din rigtige boks.",
    chooseYourPlan: "Vælg Dit Abonnement",
    restoreFullProtection: "Gendan fuld beskyttelse øjeblikkeligt",
    restorePremiumInstantly: "Gendan Premium øjeblikkeligt",
    restoreUltimateInstantly: "Gendan Ultimate øjeblikkeligt",
    instantlyRestored: "Øjeblikkeligt gendannet",
    reassurance:
      "Fortsæt præcis hvor du slap — hver funktion vil være fuldt gendannet i det øjeblik du abonnerer.",
    subscribeAndRestore: "Abonner og Gendan",
    scrollForMore: "Rul for at se mere",
    bestValue: "BEDSTE VÆRDI",
    switchToBasicDescription:
      "Du vil stadig kunne se og tilgå alle dine eksisterende fotos i appen. Dine album og medier forbliver sikre på din enhed.",
    viewAndAccess: "se og tilgå alle dine eksisterende fotos",
    premiumFeaturesDisabled: "",
    restorePremium: "Gendan Premium",
    restoreUltimate: "Gendan Ultimate",
    choosePlanToReactivate:
      "Vælg et abonnement for at genaktivere alle funktioner",
    perMonth: "/md",
    twelveMonths: "Årligt",
    oneMonth: "1 Måned",
  },
  backupPaywall: {
    title: "Backup er ikke aktiveret",
    subtitle:
      "Dine fotos og videoer er ikke sikkerhedskopieret. Abonner på Premium for at aktivere backup og låse alle funktioner op",
    subscribe: "Få Premium",
    cancelAnytime: "Ingen binding. Opsig når som helst",
  },
  lossAversion: {
    title: "Ikke ét eneste foto er nogensinde\nblevet sikkerhedskopieret.",
    subtitle:
      "Hvert foto er kun gemt på denne enhed. Mister du den, er de væk for altid.",
    photosUnprotected: "fotos\nubeskyttede",
    backedUp: "sikkerhedskopieret",
    daysAtRisk: "dage i fare",
    backupCoverage: "Sikkerhedskopidækning",
    vaultProtected: (percent: number) => `${percent}% af din boks er beskyttet`,
    premiumTitle: "Det får du med Premium",
  },
}
